import {catchError} from "rxjs/operators";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {BaseHandleErrorMapper} from "@app/core/shared/infrastructure/base.handler/base-handle-error.mapper";

@Injectable({
    providedIn: 'root'
})

export class PdfCatalogWebService {

    constructor(
        private http: HttpClient
    ) {
    }

    execute(url: string): Observable<Blob> {

        let headers = new HttpHeaders();
        headers = headers.set('Accept', 'application/pdf');
        return this.http.get(url,
            {headers: headers, responseType: 'blob'})
            .pipe(
                catchError(BaseHandleErrorMapper.handleError),
            )
    }
}

